module.exports = __webpack_public_path__ + "static/media/EMG.643abab2.jpg";